import Image from 'next/legacy/image'

import { dataByStates, ICitiesByState } from '@utils'
import s from './moreInformation.module.scss'

interface IMoreInformation {
  state?: string
  citiesByState?: ICitiesByState[]
}

export default function MoreInformation({
  state,
  citiesByState,
}: IMoreInformation) {
  const dataState =
    citiesByState[1].states.filter((elem) => elem.state_code === state).length >
    0
      ? citiesByState[1].states.filter((elem) => elem.state_code === state)
      : citiesByState[0].states.filter((elem) => elem.state_code === state)
  const dataSEOState = dataByStates.filter((elem) => elem.value === state)
  const schoolName = dataSEOState[0]?.institution
  const numberOfVets = dataSEOState[0]?.numberOfVets
  const salary = dataSEOState[0]?.annualSalary
  const dogBreed = dataSEOState[0]?.popularBreed

  return (
    <div className={s.more}>
      <div className={s.container}>
        <div className={s.image}>
          <Image
            src={
              !state
                ? '/vets/Bulldog-puppy-desktop.svg'
                : '/vets/Puppy-getting-a-check-up-desktop.svg'
            }
            alt="Bulldog puppy getting a check up at the vet"
            quality={75}
            layout="responsive"
            width={522}
            height={!state ? 300 : 350}
            objectFit="cover"
            priority
          />
        </div>
        <div className={s.text}>
          <h2 className={s.title}>
            {!state
              ? 'From New Pet to Trusted Vet: Let Mawoo Pets Help You Along the Way'
              : `Find a Local Vet in ${dataState[0]?.name} State`}
          </h2>
          {!state ? (
            <div className={s.paragraph}>
              Bringing home a new furry friend or moving to a new place can be
              an exciting adventure, but finding a vet can be a bit
              overwhelming. That's where Mawoo Pets comes to the rescue!
              <br />
              <br />
              Our vet directory can help you find some of the best vets in your
              area. View their ratings, reviews, and testimonials from verified
              customers, along with all the information you need to book your
              pup's first appointment.
              <br />
              <br />
              And if you're looking for expert pet health advice and news, be
              sure to check out our{' '}
              <a
                className={s.link}
                href={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog`}
              >
                blog
              </a>
              . We've got you and your pet covered!
            </div>
          ) : (
            <div className={s.paragraph}>
              Are you on the lookout for a skilled and loving veterinarian in{' '}
              <span>{dataState[0]?.name}</span> to take care of your furry
              friend? Look no further! Our directory lists the top veterinary
              clinics and animal hospitals in your area that offer a range of
              services, including emergency veterinary care and routine
              examinations for your best friend.
              <h3 className={s.subtitle}>Did you know?</h3>
              <ul>
                {schoolName ? (
                  <li>
                    {' '}
                    The best ranked veterinary school in{' '}
                    <span>{dataState[0]?.name}</span> is {schoolName}.{' '}
                  </li>
                ) : (
                  <li>
                    <span>{dataState[0]?.name}</span> does not currently have an
                    active veterinary school
                  </li>
                )}
                {numberOfVets && salary && (
                  <li>
                    There are over {numberOfVets} veterinarians in this state
                    and they have an average salary of {salary}.
                  </li>
                )}
                {dogBreed && (
                  <li>
                    The most popular breed in <span>{dataState[0]?.name}</span>{' '}
                    is the {dogBreed}.
                  </li>
                )}
                <li>
                  The most common reasons for veterinary visits are allergies,
                  skin issues, ear infections, dental problems, parasites,
                  vaccinations, and injuries.
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
